import { render, staticRenderFns } from "./gzhTag.vue?vue&type=template&id=6d15ae4c&scoped=true"
import script from "./gzhTag.vue?vue&type=script&lang=js"
export * from "./gzhTag.vue?vue&type=script&lang=js"
import style0 from "./gzhTag.vue?vue&type=style&index=0&id=6d15ae4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15ae4c",
  null
  
)

export default component.exports